var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177.75 69.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #41535d;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #009d96;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "msdah"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.73,20.02c0-8.45,6.85-15.23,15.23-15.23s15.23,6.85,15.23,15.23H21.73Zm0,30.46c0,8.38,6.85,15.23,15.23,15.23s15.23-6.85,15.23-15.23H21.73Zm13.85-15.3c-7.72-.73-13.77-7.21-13.77-15.16-8.45,0-15.23,6.85-15.23,15.23s6.85,15.23,15.23,15.23c0-7.94,6.05-14.43,13.77-15.16v-.15Zm2.84,.15c7.72,.73,13.77,7.21,13.77,15.16,8.38,0,15.23-6.85,15.23-15.23s-6.85-15.23-15.23-15.23c0,7.94-6.05,14.43-13.77,15.16v.15Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "98.68 35.61 92.41 20.02 82.72 20.02 82.72 50.41 89.28 50.41 89.28 28.84 98.68 50.77 98.68 50.77 108.08 28.84 108.08 50.41 114.64 50.41 114.64 20.02 104.87 20.02 98.68 35.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.04,40.86c-.22,7.58,4.96,10.42,10.93,10.57,7,.15,12.24-2.84,12.24-9.55s-6.05-7.8-10.71-9.33c-1.82-.58-5.17-1.09-5.17-4.23,0-2.62,2.26-3.86,4.52-3.86,2.99,0,4.52,1.46,4.74,4.52h5.9c0-6.05-4.59-9.55-10.13-9.55s-11.44,3.21-11.44,9.47c0,5.39,5.98,8.23,9.33,9.11,1.89,.51,6.56,1.02,6.56,4.37s-3.28,4.08-5.76,4.08c-3.21,0-5.03-2.26-4.74-5.61h-6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169,35.25c0-10.57-8.16-15.23-16.25-15.23h-9.76v30.46h9.69c8.09-.07,16.32-4.74,16.32-15.23Zm-16.76,9.62h-2.7V25.56h2.7c7.43,0,10.06,4.81,10.06,9.69,.07,4.81-2.62,9.62-10.06,9.62Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 177.75,
    height: 69.63
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsdLogo);
export default __webpack_public_path__ + "static/media/msd-logo.69d1c6e0c52dd8b71140a3c3a5a821dc.svg";
export { ForwardRef as ReactComponent };